import styles from "./EnquiryModal.module.css";
import EnquiryTravelForm, { EnquiryTravelFormData } from "./EnquiryTravelForm";

interface EnquiryIntroViewProps {
  travelDetails: EnquiryTravelFormData | null;
  onContinue: (details: EnquiryTravelFormData) => void;
}

function EnquiryIntroView(props: EnquiryIntroViewProps) {
  const { travelDetails, onContinue } = props;

  return (
    <div className={styles.modalFormContainer}>
      <h2 className={styles.title}>Create your own holiday</h2>
      <p className={styles.subtitle}>
        Can't find the experience you're looking for? Make your own! Tell us
        what you'd like and our friendly golf specialists will help make it
        happen. <strong>Best Price Guarantee.</strong>
      </p>
      <EnquiryTravelForm
        onContinue={onContinue}
        initialData={travelDetails || undefined}
      />
    </div>
  );
}

export default EnquiryIntroView;
export { EnquiryIntroView, type EnquiryIntroViewProps };
